import request from '../utils/request';

const mole = 'article';
export default {
  // 根据id获取文章信息
  findById: (id, hasparentpath) => {
    let url = `/api/${mole}/get/${id}`;
    if (hasparentpath) url = url + '?hasparentpath=1';
    return request({
      url,
      method: 'get'
    });
  },
  // 获取菜单
  findMenus: (sectionId, cutRoot = 0) => {
    return request({
      url: `/api/${mole}/list_menus/${sectionId}`,
      method: 'get',
      params: {
        cutRoot
      }
    });
  },
  // 获取文章列表
  findList: params => {
    return request({
      url: `/api/${mole}/list`,
      params: params,
      method: 'get'
    });
  },
  // 添加文章
  add: params => {
    return request({
      url: `/api/${mole}/add`,
      method: 'post',
      data: params
    });
  },
  // 添加同级目录或子目录
  addFolder: params => {
    return request({
      url: `/api/${mole}/add_folder`,
      method: 'post',
      data: params
    });
  },
  // 更新文章
  update: (id, params) => {
    return request({
      url: `/api/${mole}/update/${id}`,
      method: 'post',
      data: params
    });
  },
  delete: id => {
    return request({
      url: `/api/${mole}/delete/${id}`,
      method: 'post'
    });
  }
};
